<script setup lang="ts">
import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue"
import RegisterModal from "@/components/Common/RegisterModal.vue"
import flashMessagesType from "@/types/flashMessageType"
import { Ref, ref, reactive, computed } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import i18n from "@/lang/i18n"

const emit = defineEmits(['update:modelValue'])
const props = defineProps<{
  modelValue: boolean
  parentIdExistsDepartments: getDepartmentAllParams[]
  department: getDepartmentAllParams | null
  closeModal: (isReacquire: boolean) => void
  showFlash: (message: string, type: string, fadeout: boolean) => { value: any }
}>()

const isDeleting: Ref<boolean> = ref(false)
const isDisabled: Ref<boolean> = ref(false)
const flashMessage = reactive({
  message: "",
  show: false,
  type: "info",
  cancel: false
}) as flashMessagesType

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const message = computed(() => {
  if (isHiddenExecButton.value) return `${props.department?.name}${i18n.global.t('pages.departments.deleteModal.informationMessage')}`
  return `${props.department?.name}${i18n.global.t('pages.departments.deleteModal.deleteMessage')}`
})

const isHiddenExecButton = computed(() => {
  return !!props.parentIdExistsDepartments.filter((department) => {
    return department.parent_id == props.department?.id
  })?.length
})

function deleteDepartment() {
  isDeleting.value = true
  if (!props.department) return
  Api().deleteDepartment(props.department.id).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.removeSuccess'), "success", true)
    props.closeModal(true)
  }).catch(() => {
    changeFlashMessages("error", i18n.global.t('pages.common.messages.failedRemove'))
  }).finally(() => {
    isDeleting.value = false
    isDisabled.value = true
  })
}

function changeFlashMessages(resultStatus = "", message = "") {
  flashMessage.type = resultStatus
  flashMessage.message = message
  flashMessage.show = true
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    :title="i18n.global.t('pages.departments.deleteModal.title')"
  >
    <template v-slot:flash-message>
      <ModalFlashMessage
        id="flash-message-component"
        :message = "flashMessage.message"
        :show = "flashMessage.show"
        :type = "flashMessage.type"
        :cancel = "flashMessage.cancel"
        @setShow = "(show) => {flashMessage.show = show}"
      />
    </template>
    <template v-slot:content>
      <div class="mt-10 ml-10">
        <p>{{ message }}</p>
      </div>
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="closeModal(false)"
      >
        {{ i18n.global.t('common.closeBtn') }}
      </v-btn>
      <v-btn
        v-if="!isHiddenExecButton"
        class="ma-2 exec-btn"
        :loading="isDeleting"
        :disabled="isDisabled"
        :style="{
          backgroundColor: isDisabled ? '#B3B8BB' : '',
        }"
        @click="deleteDepartment"
      >
        {{ i18n.global.t('pages.common.button.exec') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>